import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=f426efda&scoped=true&"
import script from "./Thread.vue?vue&type=script&lang=js&"
export * from "./Thread.vue?vue&type=script&lang=js&"
import style0 from "./Thread.vue?vue&type=style&index=0&id=f426efda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f426efda",
  null
  
)

export default component.exports